import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { SetContractAutoRenewalRequestPayload } from '../../../../../libs/api-definition/src/api-definition-paths/contract-paths/set-contract-auto-renewal-path';
import {
  invalidateContractsQueries,
  invalidateCustomersQueries,
  invalidateBillingRevenueQueries,
} from '../../utils/query-invalidation';

export function useSetContractAutoRenewal(
  contractId: string,
  options?: UseMutationOptions<void, unknown, SetContractAutoRenewalRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['setContractAutoRenewal'],
    async (setContractAutoRenewalRequest) => {
      const api = getPrivateApi();

      await api.setContractAutoRenewal({
        contractId,
        setContractAutoRenewalRequest,
      });
    },
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey.includes(contractId),
          }),
          invalidateContractsQueries(queryClient),
          invalidateCustomersQueries(queryClient),
          invalidateBillingRevenueQueries(queryClient),
        ]);
      },

      ...options,
    },
  );
}
